import React from "react";
import { groupArrayByField, smoothScroll } from "../../helpers";
import { useSelector } from "react-redux";
import Category from "./Category";
import { useEffect } from "react";
import useCurrentCategory from "../../assets/hooks/useCurrentCategory";
import Product from "./Product";

export function findProductQuantity(product, basket) {
	return basket.items
		.filter(i => Number(i.product.id) === Number(product.id))
		.reduce((acc, next) => acc + next.quantity, 0);
}

export default function ProductList({
	products,
	splitCategories = true,
	showPrice = true,
	renderProduct,
	expandedByDefault = false,
	branded = true
}) {

	const { vendor, basket } = useSelector(state => ({
		vendor: state.vendor,
		basket: state.basket
	}));

	const [currentCategory] = useCurrentCategory();
	useEffect(() => {
		const category = document.querySelector(`[data-category="${currentCategory}"]`);
		smoothScroll(window, category);
	}, [currentCategory])

	const orderedProducts = products.sort((a, b) => {
		// Sorting products alphabetically by their name
		let nameA = a.name.toLowerCase();
		let nameB = b.name.toLowerCase();

		if (nameA < nameB) {
			return -1;
		}
		if (nameA > nameB) {
			return 1;
		}
		return 0;
	});

	return <div className="products">
		<div className="products-inner">
			{/* First split by product categories */}
			{splitCategories ?
				Object.entries(groupArrayByField(orderedProducts.filter(p => p.category), "category"))
					.sort((a, b) => {
						// Sorting categories alphabetically.
						let nameA = a[0].toLowerCase();
						let nameB = b[0].toLowerCase();
						if (nameA < nameB) {
							return -1;
						} else if (nameA > nameB) {
							return 1;
						} else return 0;
					})
					.map(([category, items]) => {
						// See if anything in this category has images.
						let hasImages = Boolean(items.find(item => item.images && item.images.length));

						return <Category
							key={category}
							category={category}
							items={items}
							headerColor={branded ? vendor.featureColor1 : null}
							expandedByDefault={expandedByDefault}
						>
							{items.map(product => {
								return renderProduct ?
									renderProduct(product)
									:
									(
										<Product
											showPrice={showPrice}
											key={product.id}
											product={product}
											quantity={findProductQuantity(product, basket)}
											showImage={hasImages}
											hoverState={true}
											featureColor={branded ? vendor.featureColor1 : null}
											variants={orderedProducts.filter(p => p.parent === product.id)}
										/>
									)
							})}
						</Category>
					}) : (
					orderedProducts.map(product => renderProduct ?
						(
							renderProduct(product)
						) : (
							<Product
								showPrice={showPrice}
								key={product.id}
								product={product}
								quantity={findProductQuantity(product, basket)}
								featureColor={branded ? vendor.featureColor1 : null}
								variants={orderedProducts.filter(p => p.parent === product.id)}
							/>
						))
				)
			}
		</div>
	</div>
}
